import { useSelector } from 'react-redux'

export const useGlobalConfigSelector = () => {
  const { config, loading, error } = useSelector((state: any) => state.global)

  return { config, loading, error }
}
